export const URLS = {
  // ROTAS WEB
  LOGIN: '/login',
  DASHBOARD: '/',
  PRODUTOS: '/produtos',
  BOTIJAO: '/botijao',
  USUARIOS: '/usuarios',
  CLIENTES: '/clientes',
  CONTATOS: '/contatos',
  FICHEIRO_ABS: '#',
  MOVIMENTOS: '/movimentos',
  MOVIMENTOS_IMPRESSAO: '/movimentos/impressao',
  NOTAS_FISCAIS: '/notas-fiscais',
  AUDITORIA: '/auditoria',

  // ROTAS DA API
  LOGIN_API: '/v1/auth/login',
  USER_API: '/v1/usuario',
  PRODUTOS_TIPO_API: '/v1/produto-tipos',
  PRODUTOS_API: '/v1/produto',
  PRODUTO_ID_API: '/v1/produto/id',
  ESTOQUE_API: '/v1/relatorios/estoque',
  CLIENTES_API: '/v1/cliente',
  CLIENTE_ID_API: '/v1/cliente/id',
  CONTATO_API: '/v1/contato',
  CONTATO_ESTOQUE_API: '/v1/relatorios/contato-estoque',
  CONTATO_MOVIMENTO_API: '/v1/relatorios/contato-movimento',
  NOTA_FISCAL_API: '/v1/nota-fiscal',
  NOTA_FISCAL_IMPORT_API: '/v1/nota-fiscal/importar',
  MOVIMENTOS_API: '/v1/movimento',
  MOVIMENTOS_TIPO_API: '/v1/movimento-tipos',
  BOTIJOES_API: '/v1/botijoes',
  BOTIJAO_API: '/v1/botijao',
  CANECA: '/v1/canecas',
  AUDITORIA_API: '/v1/auditoria',
  AUDITORIA_ID_API: '/v1/auditoria/id',
  ARQUIVOS_UP_TOKEN_API: '/v1/storage/sas-token',
  ARQUIVOS_LISTA_API: '/v1/storage',
  DOWNLOAD_ARQUIVO_API: '/v1/storage/download?arquivo=',
}
